var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "60px" },
          attrs: {
            title: _vm.materialName + " 的选项设置",
            width: 880,
            visible: _vm.visible,
            footer: null,
            getContainer: () => _vm.$refs.container,
            mask: _vm.isDesktop(),
            maskClosable: false,
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _c(
                "div",
                { staticClass: "group-form-card" },
                [
                  _c("div", { staticClass: "group-form-title" }, [
                    _vm._v(
                      _vm._s(_vm.groupForm.id ? "编辑选项组" : "新建选项组")
                    ),
                  ]),
                  _c(
                    "a-form",
                    { attrs: { layout: "inline" } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "组名称" } },
                        [
                          _c("a-input", {
                            staticStyle: { width: "180px" },
                            attrs: {
                              placeholder: "如：规格/加料/做法",
                              "allow-clear": "",
                            },
                            model: {
                              value: _vm.groupForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.groupForm, "name", $$v)
                              },
                              expression: "groupForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "类型" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "140px" },
                              model: {
                                value: _vm.groupForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.groupForm, "type", $$v)
                                },
                                expression: "groupForm.type",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "SINGLE" } },
                                [_vm._v("规格(单选)")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "EXTRA" } },
                                [_vm._v("加料(多选)")]
                              ),
                              _c(
                                "a-select-option",
                                { attrs: { value: "PRACTICE" } },
                                [_vm._v("做法(单选)")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "必选" } },
                        [
                          _c("a-switch", {
                            attrs: { checked: _vm.groupForm.required },
                            on: {
                              click: () =>
                                (_vm.groupForm.required =
                                  !_vm.groupForm.required),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { attrs: { label: "排序" } },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "90px" },
                            attrs: { min: 0, precision: 0 },
                            model: {
                              value: _vm.groupForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.groupForm, "sort", $$v)
                              },
                              expression: "groupForm.sort",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", loading: _vm.saving },
                              on: { click: _vm.submitGroup },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.groupForm.id ? "保存修改" : "新建组"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm.groupForm.id
                            ? _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.resetGroupForm },
                                },
                                [_vm._v("取消编辑")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.groups.length === 0
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#999",
                        padding: "24px 0",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("\n        暂无选项组，请先新建\n      ")]
                  )
                : _vm._e(),
              _vm._l(_vm.groups, function (group) {
                return _c(
                  "div",
                  { key: group.id, staticClass: "group-card" },
                  [
                    _c(
                      "div",
                      { staticClass: "group-header" },
                      [
                        _c("span", { staticClass: "group-name" }, [
                          _vm._v(_vm._s(group.name)),
                        ]),
                        _c(
                          "a-tag",
                          {
                            attrs: {
                              color: _vm.typeMeta[group.type]
                                ? _vm.typeMeta[group.type].color
                                : "",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.typeMeta[group.type]
                                    ? _vm.typeMeta[group.type].label
                                    : group.type
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _c(
                          "a-tag",
                          {
                            attrs: {
                              color: group.required === "1" ? "red" : "",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(group.required === "1" ? "必选" : "可选")
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "group-sort" }, [
                          _vm._v("排序 " + _vm._s(group.sort)),
                        ]),
                        _c(
                          "span",
                          { staticClass: "group-ops" },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.editGroup(group)
                                  },
                                },
                              },
                              [_vm._v("编辑组")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                staticStyle: { color: "red" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeGroup(group)
                                  },
                                },
                              },
                              [_vm._v("删除组")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.addValue(group)
                                  },
                                },
                              },
                              [_vm._v("添加值")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-table", {
                      attrs: {
                        size: "small",
                        bordered: "",
                        pagination: false,
                        rowKey: "id",
                        columns: _vm.valueColumns,
                        dataSource: group.values,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "priceSlot",
                            fn: function (text) {
                              return [
                                text !== null &&
                                text !== undefined &&
                                Number(text) > 0
                                  ? _c("span", [_vm._v("+" + _vm._s(text))])
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                          {
                            key: "valueAction",
                            fn: function (text, record) {
                              return _c(
                                "span",
                                {},
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.editValue(group, record)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "red" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeValue(record)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ],
                                1
                              )
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "a-modal",
            {
              staticStyle: { top: "200px" },
              attrs: {
                title: _vm.valueForm.id ? "编辑选项值" : "添加选项值",
                visible: _vm.valueVisible,
                confirmLoading: _vm.valueSaving,
                getContainer: () => _vm.$refs.container,
                mask: false,
                maskClosable: false,
                cancelText: "取消",
                okText: "保存",
              },
              on: {
                ok: _vm.submitValue,
                cancel: function ($event) {
                  _vm.valueVisible = false
                },
              },
            },
            [
              _c(
                "a-form",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "值名称",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "如：大份/加冰/微辣",
                          "allow-clear": "",
                        },
                        model: {
                          value: _vm.valueForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.valueForm, "name", $$v)
                          },
                          expression: "valueForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "加价",
                      },
                    },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          min: 0,
                          precision: 2,
                          placeholder: "选该值时加收金额",
                        },
                        model: {
                          value: _vm.valueForm.addPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.valueForm, "addPrice", $$v)
                          },
                          expression: "valueForm.addPrice",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "排序",
                      },
                    },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, precision: 0 },
                        model: {
                          value: _vm.valueForm.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.valueForm, "sort", $$v)
                          },
                          expression: "valueForm.sort",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }